import moment from "moment";

const getInterval = (type, dpeTable) => {
  if (type === "DPE_ENEP") {
    return [
      0,
      dpeTable?.energy_a,
      dpeTable?.energy_b,
      dpeTable?.energy_c,
      dpeTable?.energy_d,
      dpeTable?.energy_e,
      dpeTable?.energy_f
    ]
  }
  return [
    0,
    dpeTable?.ghg_a,
    dpeTable?.ghg_b,
    dpeTable?.ghg_c,
    dpeTable?.ghg_d,
    dpeTable?.ghg_e,
    dpeTable?.ghg_f
  ]
}

const getNote = (value, dpeTable, type) => {
  let name = "energy_";
  if (type === "DPE_GHG") {
    name = "ghg_"
  }
  if (value === null || value === undefined || !dpeTable) {
    return null;
  }
  if (value > dpeTable?.[name + "f"]) {
    return "G"
  } else if (value > dpeTable?.[name + "e"]) {
    return "F"
  } else if (value > dpeTable?.[name + "d"]) {
    return "E"
  } else if (value > dpeTable?.[name + "c"]) {
    return "D"
  } else if (value > dpeTable?.[name + "b"]) {
    return "C"
  } else if (value > dpeTable?.[name + "a"]) {
    return "B"
  }
  return "A";
}

const getColors = (type) => {
  if (type === "DPE_GHG") {
    return {
      "A": "#f5eef6",
      "B": "#dac0dd",
      "C": "#c8a9cf",
      "D": "#bd99c4",
      "E": "#a274b6",
      "F": "#a274b6",
      "G": "#784a9c"
    }
  }
  return {
    "A": "#2e994c",
    "B": "#54b751",
    "C": "#aad956",
    "D": "#f6ea0c",
    "E": "#fdcc0c",
    "F": "#f89839",
    "G": "#ee1f25"
  }
}

const getObjectiveYear = (type, data, crremObjectivesTable) => {
  let value = null;
  if (!crremObjectivesTable || !data) return null;
  let prefix = type === "CRREM_PCS" ? "energy" : "ghg";
  for (let i = 2020; i <= 2050; i++) {
    if (type === "CRREM_GHG") {
      value = data?.performances?.find((p) => p.type === "CRREM_GHG")?.values?.find((v) => v.year === i)?.value;
    }
    else {
      value = data?.performances?.find((p) => p.type === "CRREM_PCS")?.value;
    }
    if (i === 2020 && value > crremObjectivesTable[`${prefix}_${i}`]) {
      return 0; // year passed
    } else if (value > crremObjectivesTable[`${prefix}_${i}`]) {
      return i; // year where the performance is greater than the objective
    }
  }
  return 1; // year not passed
}

const getWorstYearType = (energy_year, ghg_year) => {
  if (energy_year ===  ghg_year) {
    return "CRREM_PCS";
  } else if (energy_year === 0 || ghg_year === 1) {
    return "CRREM_PCS";
  } else if (ghg_year === 0 || energy_year === 1) {
    return "CRREM_GHG";
  } else if (energy_year < ghg_year) {
    return "CRREM_PCS";
  } else {
    return "CRREM_GHG";
  }
}

const getWorstCrremValue = (data, worst_crrem_type, worst_year) => {
  let value = null;
  if (worst_crrem_type === "CRREM_PCS") {
    value=data?.performances?.find((p) => p.type === "CRREM_PCS")?.value;
  } else if (worst_crrem_type === "CRREM_GHG" && worst_year === 0) {
    value=data?.performances?.find((p) => p.type === "CRREM_GHG")?.values[0]?.value;
  } else if (worst_crrem_type === "CRREM_GHG" && worst_year === 1) {
    value=data?.performances?.find((p) => p.type === "CRREM_GHG")?.values?.slice(-1)[0]?.value;
  } else {
    value=data?.performances?.find((p) => p.type === "CRREM_GHG")?.values?.find((v) => v.year === worst_year)?.value;
  }
  return value ? Math.round(value * 100) / 100 : null;
}

const getObjectiveText = (year) => {
  if (year === 0) {
    return "<" + (moment().year() - 1);
  } else if (year === 1) {
    return ">2050"
  } else {
    return year
  }
};

export {getInterval, getNote, getColors, getObjectiveYear, getObjectiveText, getWorstYearType, getWorstCrremValue};